import { memo } from 'react';
import { useSelector } from '@xstate/store/react';
import { useCanvasStores } from '../stores/CanvasContext';

function BoxSelectOverlayInner() {
  const { dragStore } = useCanvasStores();
  const boxSelectRect = useSelector(dragStore, s => s.context.boxSelectRect);
  if (!boxSelectRect) return null;
  return (
    <div
      style={{
        position: 'absolute',
        left: boxSelectRect.x,
        top: boxSelectRect.y,
        width: boxSelectRect.width,
        height: boxSelectRect.height,
        backgroundColor: 'rgba(59, 130, 246, 0.1)',
        border: '1px solid rgba(59, 130, 246, 0.4)',
        borderRadius: 2,
        pointerEvents: 'none',
      }}
    />
  );
}

export const BoxSelectOverlay = memo(BoxSelectOverlayInner);
